<template>
  <div class="challenges-header">
    <h1>challenges</h1>
    <div
      v-if="categories.length"
      class="view-choice"
      role="group"
      aria-label="Show challenges as"
    >
      <button
        class="button"
        :class="{current: view === 'map'}"
        :aria-pressed="view === 'map'"
        @click="setView('map')"
      >
        Map
      </button>
      <button
        class="button"
        :class="{current: view === 'list'}"
        :aria-pressed="view === 'list'"
        @click="setView('list')"
      >
        List
      </button>
    </div>
  </div>
  <template v-if="categories.length">
    <ChallengeMap v-if="view === 'map'" />
    <template v-else>
      <ChallengeCategory
        v-for="category in categories"
        :key="category"
        :name="category"
      />
    </template>
  </template>
  <p v-if="$store.state.watsupReturned && !$store.state.categories.length" class="mc-panel not-started">
    CTF hasn't started yet!
  </p>
</template>

<script>
import ChallengeCategory from '@/components/ChallengeCategory.vue'
import ChallengeMap from '@/components/ChallengeMap.vue'

// Which view was picked last, per browser.
const VIEW_KEY = 'challengeView'

function savedView () {
    try {
        const view = window.localStorage.getItem(VIEW_KEY)
        if (view === 'map' || view === 'list') return view
    } catch {}
    // The map needs some room; phones get the list unless they ask.
    return window.innerWidth >= 720 ? 'map' : 'list'
}

export default {
    components: {
        ChallengeCategory,
        ChallengeMap,
    },
    data () {
        return {
            view: savedView(),
        }
    },
    computed: {
        categories () {
            return this.$store.state.categories
        },
    },
    watch: {
        $route (to, from) {
            if (to.name === 'challenge' || to.name === 'challenges') this.navigate(to.params.id)
        },
        '$store.state.challenges': { // This probably gets called too often and creates unnecessary overhead because its a deep watch, but idk
            handler () {
                if (!this.$store.state.modals.challengeModal.visible && this.$route.params.id) {
                    this.navigate(this.$route.params.id)
                }
            },
            deep: true,
        },
    },
    mounted () {
        this.navigate(this.$route.params.id)
    },
    methods: {
        navigate (id) {
            if (id !== undefined && id in this.$store.state.challenges) {
                this.$store.commit('setModalChallenge', this.$store.state.challenges[id])
                this.$store.commit('showModal', 'challengeModal')
            } else {
                this.$store.commit('hideModal', 'challengeModal')
            }
        },
        setView (view) {
            this.view = view
            try {
                window.localStorage.setItem(VIEW_KEY, view)
            } catch {}
        },
    },
}
</script>

<style lang="scss" scoped>
.challenges-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem 1rem;
    margin-bottom: 1rem;

    h1 {
        margin-bottom: 0;
    }
}

.view-choice {
    display: flex;

    .button + .button {
        margin-left: -$mc-px;
    }
}

.current {
    background-color: $ssm-teal;
    color: $ssm-ink;
    text-shadow: none;

    &:hover {
        background-color: lighten($ssm-teal, 8%);
    }
}

.not-started {
    display: inline-block;
}
</style>
